<template>
    <div class="card">
        <div class="card-header">
            <h4 class="card-title">
                <template v-if="config===1 && valor==='T' ">
                    {{$t("planoDeTaquillas")}}
                </template>
                <template v-else>{{$t("planoDeMesas")}}</template>
            </h4>
            <p class="card-category">
                <template v-if="config===1 && valor==='T'">
                    {{$t("situacionActualDeOcupacionDeTaquillas")}}
                </template>
                <template v-else>
                    {{$t("situacionActualDeOcupacionDeMesas")}}
                </template>
            </p>
            <div class="text-right">
                <router-link :to="{name:'plano-mesas', params:{idBusiness:idBusiness}}">
                    <span class="verTodos"><i class="fa fa-eye"></i> {{$t("verPlanoCompleto")}}</span>
                </router-link>
            </div>
        </div>

        <div class="card-body">
            <div class="row">

                <div class="col-md-12">
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                            <tr>
                                <th>{{$t("verPlanoCompleto")}}</th>
                                <th><template v-if="config===1 && valor==='T'">{{$t("taquillas")}}</template> <template v-else>{{$t("mesas")}}</template></th>
                                <th>{{$t("ocupacion")}}</th>
                                <th>{{$t("enPlano")}}</th>
                                <th>{{$t("total")}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="m in listMesas">
                                <td>{{m.plano}}</td>
                                <td>{{m.abiertas}} / {{m.total}}</td>
                                <td align="right"><span v-if="m.total>0">{{parseFloat(Math.round((m.abiertas / m.total*100)*100)/100).toFixed(2)}} %</span><span
                                        v-else>0.00 %</span></td>
                                <td align="right">{{m.numPosits}}</td>
                                <td align="right">{{m.amount + m.totalPosits | currency}}</td>
                            </tr>
                            <tr class="table-success">
                                <td><strong>{{$t("total")}}:</strong></td>
                                <td><strong>{{getMesasTotal}} / {{numMesas}}</strong></td>
                                <td align="right"><strong>{{Math.round(getOcupacionTotal*100)/100}} %</strong></td>
                                <td align="right"><strong>{{getPositsTotal}}</strong></td>
                                <td align="right"><strong>{{getAmountTotal | currency}}</strong></td>
                            </tr>
                            </tbody>
                            <tfoot>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock"></i> {{lastDate | timeago}}
            </div>
        </div>
    </div>
</template>

<script>
    import Terms from "../../../GeneralViews/Terms";

    export default {
        name: "PlanosMesas",
        components: {Terms},
        props: ['onlineDetails', 'lastDate', 'idBusiness'],

        created() {

            this.getPlanos();
            this.configuracion();
        },
        computed: {
            getAmountTotal() {
                let total = 0;
                this.listMesas.forEach(function (d) {
                    total += d.amount + d.totalPosits;
                });
                return total;
            },
            getMesasTotal() {
                let total = 0;

                this.listMesas.forEach(function (d) {

                    total += d.abiertas;
                });
                return total;
            },
            getOcupacionTotal() {
                let total = 0;
                let vm = this;
                this.listMesas.forEach(function (d) {
                    total += Math.round((d.abiertas / vm.numMesas * 100) * 100) / 100;
                });
                return total;
            },

            getPositsTotal() {
                let total = 0;
                let vm = this;
                this.listMesas.forEach(function (d) {
                    total += d.numPosits;
                });
                return total;
            }


        },
        data() {
            return {
                listMesas: [],
                numMesas: 0,

                config: false,
                valor: false,
            }
        },

        methods: {

            getPlanos() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "online/getPlanos", config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.listMesas = response.data.result.mesas;
                            vm.numMesas = response.data.result.totalMesas
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            configuracion() {

                var vm = this;


                if (this.onlineDetails[0]) {

                    this.onlineDetails[0].listConfig.forEach(function (x) {


                        if (x.idConfig === 1 || x.valor === 'T') {
                            vm.config = x.idConfig;
                            vm.valor = x.valor;
                        }

                    })
                }


            }
        }
    }
</script>

<style scoped>

    .card-category {
        color: #9a9a9a
    }

    .card-body {
        padding: 10px 15px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Online/Widgets/PlanoMesas.vue